var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAkarIconsChatApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.647C17.771 19.647 19.657 19.647 20.828 18.475C22 17.304 22 15.418 22 11.647C22 7.87597 22 5.98997 20.828 4.81897C19.657 3.64697 17.771 3.64697 14 3.64697H10C6.229 3.64697 4.343 3.64697 3.172 4.81897C2 5.98997 2 7.87597 2 11.647C2 15.418 2 17.304 3.172 18.475C3.825 19.129 4.7 19.418 6 19.545",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.647L11.25 13.647L15 9.64697",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.647C12.764 19.647 11.402 20.147 10.159 20.792C8.161 21.829 7.162 22.348 6.67 22.017C6.178 21.687 6.271 20.662 6.458 18.613L6.5 18.147",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsChatApprove);
export default __webpack_public_path__ + "static/media/akar-icons_chat-approve.9705dfa10ef1421dade6ffaaac76c5b5.svg";
export { ForwardRef as ReactComponent };